/**
 * Partenaires / entreprises qui travaillent avec nous.
 * Ajoutez des entrées : { id, name, logo: "/assets/...", url?: "https://..." }
 */
export const partners = [
  {
    id: "1",
    name: "Voyage Privé",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Voyage_Priv%C3%A9.svg/1280px-Voyage_Priv%C3%A9.svg.png",
    url: "https://www.voyage-prive.com",
  },
  {
    id: "2",
    name: "Enersol",
    logo: "https://www.enersol.be/website_enersol/static/src/img/brand/logo.svg",
    url: "https://www.enersol.be",
  },
  {
    id: "3",
    name: "Axigap",
    logo: "/assets/siclade.png",
    url: "https://axigap.com",
  },
  {
    id: "4",
    name: "Euro Chape Fluide",
    logo: "https://eurochapefluide.com/assets/ecf-transparent.64f9444cff744a1b9314.png",
    url: "https://eurochapefluide.com",
  },
  {
    id: "5",
    name: "Isotrie",
    logo: "/logo_isotrie.png",
  },
  {
    id: "6",
    name: "Swartr",
    logo: "/logo_swartr.png",
  },
  {
    id: "7",
    name: "Gescem",
    logo: "/logo_gescem.png",
  },
];
